export enum CostMeasureType {
    CostValue,
    CostAsPercentageOfRevenue
}
